import { z } from 'zod';
export var EBoksRecipientType;
(function (EBoksRecipientType) {
    EBoksRecipientType["KVHX"] = "KVHX";
    EBoksRecipientType["CentralRegisterId"] = "CENTRAL_REGISTER_ID";
})(EBoksRecipientType || (EBoksRecipientType = {}));
export const EBoksRecipientSchema = z.union([
    z.object({
        type: z.literal(EBoksRecipientType.KVHX),
        firstName: z.string(),
        lastName: z.string(),
        kvhx: z.string().nullable(),
    }),
    z.object({
        type: z.literal(EBoksRecipientType.CentralRegisterId),
        centralRegisterId: z.string(),
        isCompany: z.boolean(),
    }),
]);
//# sourceMappingURL=eboks.js.map